export default __webpack_public_path__ + "static/media/HeadShot.b4f6c741.png";